var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"InstructionsButton",on:{"click":function($event){return _vm.goToInstructions()}}},[_vm._v(" "+_vm._s(_vm.$t('components.instructions-button.instructions'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }